/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  HookIngestData,
  HookIngestData$Outbound,
  HookIngestData$outboundSchema,
} from "./hookingestdata.js";
import {
  HookIngestEvent,
  HookIngestEvent$Outbound,
  HookIngestEvent$outboundSchema,
} from "./hookingestevent.js";
import {
  HookIngestSession,
  HookIngestSession$Outbound,
  HookIngestSession$outboundSchema,
} from "./hookingestsession.js";
import {
  HookIngestSource,
  HookIngestSource$Outbound,
  HookIngestSource$outboundSchema,
} from "./hookingestsource.js";

export type IngestRequestBody = {
  /**
   * Feature-specific payloads. Hooks populate only the blocks needed for the event.
   */
  data?: HookIngestData | undefined;
  /**
   * Canonical Speakeasy feature event.
   */
  event: HookIngestEvent;
  /**
   * Original provider payload for debugging. The backend does not use this for feature behavior.
   */
  raw?: any | undefined;
  /**
   * Contract version. The current version is hook.ingest.v1.
   */
  schemaVersion: string;
  /**
   * Agent session and turn identity, independent of provider naming.
   */
  session?: HookIngestSession | undefined;
  /**
   * Metadata about the local hook adapter that translated a provider event into the Speakeasy hook contract.
   */
  source: HookIngestSource;
};

/** @internal */
export type IngestRequestBody$Outbound = {
  data?: HookIngestData$Outbound | undefined;
  event: HookIngestEvent$Outbound;
  raw?: any | undefined;
  schema_version: string;
  session?: HookIngestSession$Outbound | undefined;
  source: HookIngestSource$Outbound;
};

/** @internal */
export const IngestRequestBody$outboundSchema: z.ZodMiniType<
  IngestRequestBody$Outbound,
  IngestRequestBody
> = z.pipe(
  z.object({
    data: z.optional(HookIngestData$outboundSchema),
    event: HookIngestEvent$outboundSchema,
    raw: z.optional(z.any()),
    schemaVersion: z.string(),
    session: z.optional(HookIngestSession$outboundSchema),
    source: HookIngestSource$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      schemaVersion: "schema_version",
    });
  }),
);

export function ingestRequestBodyToJSON(
  ingestRequestBody: IngestRequestBody,
): string {
  return JSON.stringify(
    IngestRequestBody$outboundSchema.parse(ingestRequestBody),
  );
}
